// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import allRoutes from "routes";
// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useRecoilValue } from "recoil";
import { RouteConfigState } from "../../states";
// Hàm flattenItems gôm tất cả các route con vào một mảng ngang hàng
function flattenItems(array) {
  const flattenedArray = [];
  array.forEach((item) => {
    if (item.collapse) {
      flattenedArray.push({ ...item, component: null });
      flattenedArray.push(...flattenItems(item.collapse));
    } else {
      flattenedArray.push({ ...item, component: null });
    }
  });
  return flattenedArray;
}
function Breadcrumbs({
  icon,
  title,
  route,
  light = false,
  home = "/dashboard",
}) {
  const routes = route.slice(0, -1);
  const routesValue = useRecoilValue(RouteConfigState);
  const allRoutesNew = flattenItems(routesValue);
  let el_route = allRoutesNew?.find((item) => item.key === title);
  return (
    allRoutesNew &&
    allRoutesNew.length > 0 && (
      <MDBox mr={{ xs: 0, xl: 8 }}>
        <MuiBreadcrumbs
          separator="›"
          sx={{
            "& .MuiBreadcrumbs-separator": {
              color: ({ palette: { white, grey } }) =>
                light ? white.main : grey[600],
            },
          }}
        >
          <Link to={home}>
            <MDTypography
              component="span"
              variant="body2"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              <Icon>{icon}</Icon>
            </MDTypography>
          </Link>
          {routes.map((el) => {
            let el_route = allRoutesNew.find((item) => item.key === el);
            return (
              <Link key={el} to={el_route?.route}>
                <MDTypography
                  component="span"
                  variant="button"
                  fontWeight="regular"
                  textTransform="capitalize"
                  color={light ? "white" : "dark"}
                  opacity={light ? 0.8 : 0.5}
                  sx={{
                    lineHeight: 0,
                  }}
                >
                  {el_route?.name}
                </MDTypography>
              </Link>
            );
          })}
          {el_route && el_route.name && (
            <MDTypography
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              sx={{
                // lineHeight: 0,
                whiteSpace: "break-spaces",
              }}
            >
              {el_route.name}
            </MDTypography>
          )}
        </MuiBreadcrumbs>
      </MDBox>
    )
  );
}

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
  home: PropTypes.string,
};

export default Breadcrumbs;
